import React from 'react';

import SidebarMenuCategoryHeader from './SidebarMenuCategoryHeader';
import SidebarMenuItem from './SidebarMenuItem';

const SidebarMenuOverview = () => {
  return (
    <>
      <SidebarMenuCategoryHeader title={'MAIN VIEWS'} />
      <SidebarMenuItem to={`/overview`} label={'Market Summary'} />
    </>
  );
};

export default SidebarMenuOverview;
